import { useRefetchQuery } from "libs/reactQuery";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";

import { UnverifiedResellersCountEventData } from "../siteBarCounters.types";

export const useVerificationsCounter = () => {
  const { resellerSocket } = useContext(SocketsContext);

  const [unverifiedResellersCount, setUnverifiedResellersCount] =
    useState<number>(0);

  const refetchUnverifiedResellers = useRefetchQuery([
    "reseller",
    "admin",
    "unverified",
    "all"
  ]);

  useEffect(() => {
    if (resellerSocket.socket) {
      resellerSocket.socket?.on(
        "unverified-resellers-count",
        (data: UnverifiedResellersCountEventData) => {
          if (data.countOfUnverifiedResellers) {
            setUnverifiedResellersCount(data.countOfUnverifiedResellers);
          }
          if (data.unverifiedResellersCount === "Incremented") {
            setUnverifiedResellersCount((prev) => prev + 1);
            refetchUnverifiedResellers();
          }
          if (data.unverifiedResellersCount === "Decremented") {
            setUnverifiedResellersCount((prev) => prev - 1);
          }
        }
      );
    }

    return () => {
      resellerSocket?.socket?.off("unverified-resellers-count");
    };
  }, [resellerSocket.socket]);

  return { unverifiedResellersCount };
};
